<template>
  <Modal
    title="选择部门"
    v-model="visibleDialog"
    width="800px"
    transfer
    class="promoter_group"
    :mask-closable="false"
  >
    <groupSelect
      v-if="visibleDialog"
      :list.sync="list"
      :multiple="true"
      :selectList.sync="selectList"
      :selectedIds.sync="selectedIds"
      :selectGroupIds.sync="selectGroupIds"
      :originData="originData"
      :customTreeList.sync="customTreeList"
    />
    <span slot="footer" class="dialog-footer">
      <Button @click="$emit('update:visible', false)">取 消</Button>
      <Button type="primary" @click="saveDialog">确 定</Button>
    </span>
  </Modal>
</template>

<script>
import { groupSelect } from '@/components/personDepartmentRoleSelect';
import mixins from './mixins';
export default {
  components: { groupSelect },
  mixins: [mixins],
  props: ['visible', 'selected'],
  watch: {
    visible(val) {
      this.visibleDialog = this.visible;
      if (val) {
        this.getDepartmentList(this.selected);
        // this.getDepartmentInfo();
      }
    },
    visibleDialog(val) {
      this.$emit('update:visible', val);
    }
  },
  computed: {},
  data() {
    return {
      visibleDialog: false,
      list: [],
      selectList: [],
      selectedIds: [],
      selectGroupIds: [],
      originData: [],
      customTreeList: []
    };
  },
  methods: {
    saveDialog() {
      this.$emit('change', this.selectList);
    },
    getDepartmentInfo() {
      console.log(111);
    }
  }
};
</script>

<style lang="less">
@import './dislogStyle/dialog.css';
</style>
